import { render, staticRenderFns } from "./IconSvgFlac.vue?vue&type=template&id=458bec64&scoped=true&"
import script from "./IconSvgFlac.vue?vue&type=script&lang=js&"
export * from "./IconSvgFlac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458bec64",
  null
  
)

export default component.exports